import AssignManufacturer from './AssignManufacturer';
export default AssignManufacturer;
